﻿import React, {Component} from 'react';
import PropTypes from "prop-types";
import TemplatesList from './templates-list'
import { IconButton } from 'material-ui';
import AddIcon from 'material-ui/svg-icons/content/add';
import ListAppBar from '../core/list-app-bar';

class Templates extends Component {
    render() {
        return (
            <div>
                <ListAppBar title="Templates"
                        iconElementRight={
                            <IconButton href={'/template/0'}><AddIcon /></IconButton>
                        }
                />
                <TemplatesList />
            </div>

        )
    }
}

Templates.contextTypes = {
    router: PropTypes.any.isRequired
};

export default Templates;